import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "اختيار رقم عشوائي";
const DESCRIPTION =
  "مولد الأرقام العشوائية هو أداة تساعدك في توليد أرقام ضمن نطاق محدد تقوم بتعيينه، ويمكنك اختيار رقم عشوائي أو عدة أرقام عشوائية مثل رقم عشوائي من 1 إلى 100 أو رقم عشوائي من 1 الى 10.";
const KEYWORDS =
  "اختيار رقم عشوائي, رقم عشوائي, ارقام عشوائية, رقم عشوائي من 1 إلى 100, رقم عشوائي من 1 الى 10, مولد الأرقام العشوائية, توليد أرقام عشوائية, أداة مولد الأرقام";
const OG_URL = "https://do-calculate.com/calculator/ar/random-number-generator";
function RandomNumberGenerator() {
  const [min, setMin] = useState("0");
  const [max, setMax] = useState("100");
  const [count, setCount] = useState("1");
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const handleMinChange = (event) => {
    setMin(event.target.value);
  };
  const handleMaxChange = (event) => {
    setMax(event.target.value);
  };
  const handleCountChange = (event) => {
    setCount(event.target.value);
  };
  const generateRandomNumbers = () => {
    const minNum = parseInt(min);
    const maxNum = parseInt(max);
    const countNum = parseInt(count);
    if (
      isNaN(minNum) ||
      isNaN(maxNum) ||
      isNaN(countNum) ||
      minNum >= maxNum ||
      countNum <= 0
    ) {
      setError("يرجى إدخال قيم صحيحة.");
      setResults([]);
      return;
    }
    const randomNumbers = Array.from(
      { length: countNum },
      () => Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum
    );
    setResults(randomNumbers);
    setError(null);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مولد الأرقام العشوائية هو أداة تساعدك على اختيار رقم عشوائي أو
                  توليد أرقام عشوائية ضمن نطاق معين. يسمح لك بتحديد الحد الأدنى
                  والحد الأقصى للنطاق، بالإضافة إلى عدد الأرقام العشوائية التي
                  ترغب في توليدها، مثل توليد رقم عشوائي من 1 إلى 100 أو رقم
                  عشوائي من 1 الى 10. تستخدم هذه الأداة عادة في مجالات مختلفة
                  مثل الإحصاءات، التشفير، والمحاكاة. يعتبر مولد الأرقام
                  العشوائية أساسياً في ضمان العدالة في ألعاب الحظ، إنشاء مفاتيح
                  تشفير آمنة، إجراء الأبحاث العلمية، واختبار تطبيقات البرمجيات.
                  من خلال استخدام مولد الأرقام العشوائية، يمكنك القضاء على
                  التحيز والتنبؤ، مما يضمن أن كل رقم يتم توليده هو حقاً عشوائي
                  ومستقل عن الأرقام السابقة. هذه الأداة قيمة لإنشاء رموز فريدة،
                  كلمات مرور، وعينات عشوائية للتحليل الإحصائي. بشكل عام، مولد
                  الأرقام العشوائية هو أداة متعددة الاستخدامات توفر العشوائية
                  والتنبؤ في تطبيقات مختلفة.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  اختيار رقم عشوائي - مولد الأرقام العشوائية
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="min" className="form-label ms-2">
                      الحد الأدنى
                    </label>
                  </b>
                  <input
                    type="number"
                    id="min"
                    value={min}
                    onChange={handleMinChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="0"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="max" className="form-label ms-2">
                      الحد الأقصى
                    </label>
                  </b>
                  <input
                    type="number"
                    id="max"
                    value={max}
                    onChange={handleMaxChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="100"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="count" className="form-label ms-2">
                      عدد الأرقام
                    </label>
                  </b>
                  <input
                    type="number"
                    id="count"
                    value={count}
                    onChange={handleCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="1"
                  />
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={generateRandomNumbers}
                  >
                    إحسب                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <div>
                  { error && (
                    <div className="alert alert-warning">
                      <b>
                        <u>خطأ:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { results.length > 0 && (
                    <div>
                      <h4>النتائج:</h4>
                      <hr />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        <ul>
                          {results.map((num, index) => (
                            <li key={index}>{num}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كيف تستخدم مولد الأرقام العشوائية؟
              </div>
              <div className="info-section-body">
                <h2>كيف تستخدم مولد الأرقام العشوائية؟</h2>
                <p>
                  لاستخدام مولد الأرقام العشوائية، كل ما عليك فعله هو تحديد الحد
                  الأدنى والحد الأقصى للنطاق الذي تود أن يظهر فيه الرقم
                  العشوائي. يمكنك توليد رقم عشوائي واحد أو عدة أرقام عشوائية
                  بحسب احتياجاتك. على سبيل المثال، إذا كنت ترغب في اختيار رقم
                  عشوائي من 1 إلى 100، قم بتعيين 1 كحد أدنى و100 كحد أقصى. بعد
                  ذلك، قم بتحديد عدد الأرقام العشوائية التي ترغب في توليدها.
                  أخيراً، اضغط على زر "إحسب" للحصول على النتائج. يمكن استخدام
                  هذا في مجالات متعددة، مثل إجراء سحوبات أو توزيع جوائز أو حتى
                  لاختيار أرقام عشوائية في الألعاب.
                </p>
              </div>
            </div>
          </div>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هو مولد الأرقام العشوائية؟</div>
              <div className="info-section-body">
                <h2>ما هو مولد الأرقام العشوائية؟</h2>
                <p>
                  مولد الأرقام العشوائية هو أداة مبتكرة تساعدك على توليد أرقام
                  عشوائية ضمن نطاق معين يتم تعيينه حسب رغبتك. سواء كنت بحاجة إلى
                  اختيار رقم عشوائي من 1 الى 10 أو توليد ارقام عشوائية أكبر مثل
                  رقم عشوائي من 1 إلى 100، فإن هذه الأداة توفر لك المرونة لتحديد
                  النطاق المناسب. بالإضافة إلى ذلك، يمكنك تحديد عدد الأرقام التي
                  ترغب في توليدها دفعة واحدة، مما يجعل هذه الأداة مثالية
                  للاستخدام في مجالات متعددة مثل الإحصاءات، التشفير، الألعاب،
                  وأي نشاط يتطلب إنتاج أرقام عشوائية حقيقية.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default RandomNumberGenerator;
